import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ProjectsSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const ProjectsSection = () => {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();
  const scrollRef = useRef(null);
const handleScroll = (dir) => {
    scrollRef.current.scrollBy({
      left: dir === "right" ? 300 : -300,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await axios.get("/project");
      const nonDeleted = res.data.filter((p) => p.deletedAt === null);
      setProjects(nonDeleted);
    } catch (error) {
      console.error("Erreur lors du chargement des projets", error);
    }
  };

  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((p) => p.serviceType?.toLowerCase() === filter.toLowerCase());

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <div className="projects-section">
      {/* Title */}
      <h2 className="projects-title">Nos Projets</h2>
      <p className="projects-subtitle">
        Nos prestations de services tournent principalement sur le développement
        des sites web et des applications mobiles.
      </p>

      {/* Filter buttons */}
      <div className="filter-bar">
        <button
          className={filter === "mobile" ? "active" : ""}
          onClick={() => setFilter("Développement Mobile")}
        >
          Mobile
        </button>
        <button
          className={filter === "web" ? "active" : ""}
          onClick={() => setFilter("Développement Web")}
        >
          Web
        </button>
        
      </div>

      {/* Projects list with scroll */}
      <div className="projects-list-container">
         <button className="arrow-btn left" onClick={() => handleScroll("left")}>
                                 <FontAwesomeIcon icon={faChevronLeft} />
                               </button>
        <div className="projects-list" ref={scrollRef}>
          {filteredProjects.length > 0 ? (
            filteredProjects.map((p) => (
              <div key={p.id} className="project-card">
                <div className="project-content">
                  <h3 className="project-title">{p.projectName}</h3>
                  <p className="project-description1">{p.about}</p>
                </div>
                {p.imageUrl && (
                  <img
                    src={`/${p.imageUrl}`}
                    alt={p.projectName}
                    className="project-image"
                  />
                )}
              </div>
            ))
          ) : (
            <p className="no-project">Aucun projet trouvé.</p>
          )}
        </div>

        {/* Scroll arrow */}
        <button className="arrow-btn right" onClick={() => handleScroll("right")}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                  </button>
      </div>

      {/* Manage projects button */}
      <div className="clients-btn">
        <button onClick={() => navigate("/admin/projects")}>
          Gérer les projets
        </button>
      </div>
    </div>
  );
};

export default ProjectsSection;
